import { z } from "zod";
const audioId = z.string().regex(/^[a-z0-9-]{1,80}$/);
const ids = z
    .array(z.string().regex(/^[1-9][0-9]{0,18}$/))
    .max(100)
    .refine((v) => new Set(v).size === v.length);
export const pressOneConfigSchema = z
    .object({
    name: z.string().trim().min(1).max(100),
    sourceIds: z
        .array(z.number().int().positive())
        .max(100)
        .refine((v) => new Set(v).size === v.length),
    dispatcherIds: ids,
    transferMode: z
        .enum(["dispatcher_first", "sasha_only"])
        .default("dispatcher_first"),
    introAudioId: audioId,
    holdAudioId: audioId.nullable(),
    maxConcurrentCalls: z.number().int().min(1).max(30),
    outboundTrunkIds: z.array(z.number().int().positive()).max(2).refine(v => new Set(v).size === v.length).default([]),
    maxCallsPerTrunk: z.number().int().min(1).max(30).default(30),
    recordCalls: z.boolean().default(false),
    recordingMaxSeconds: z.number().int().min(15).max(180).default(90),
    introMaxPlays: z.number().int().min(1).max(2).default(2),
    menuTimeoutSeconds: z.number().int().min(10).max(60).default(40),
    operatorWaitSeconds: z.number().int().min(1).max(30).default(12),
    detectionMode: z.enum(["off", "observe", "hangup"]).default("observe"),
    machinePhrases: z
        .array(z.string())
        .transform((values) => [
        ...new Set(values.map((v) => v.trim()).filter(Boolean)),
    ])
        .pipe(z.array(z.string().min(10).max(500)).max(200))
        .default([]),
    dialingMode: z.enum(["fixed", "adaptive"]).default("adaptive"),
    pacingSampleSize: z.number().int().min(50).max(1000).default(100),
    maxOverflowPercent: z.number().min(0.1).max(10).default(2),
    aiProvider: z.enum(["none", "sasha"]).default("none"),
    aiMaxConcurrentCalls: z.number().int().min(1).max(30).default(2),
    sashaInboundTarget: z.string().trim().max(200).default(""),
    priceAttemptKop: z.number().int().min(0).max(100000).default(74),
    priceMinuteKop: z
        .number()
        .int()
        .min(0)
        .max(100000)
        .nullable()
        .default(null),
    baseContactKop: z
        .number()
        .int()
        .min(0)
        .max(1000000)
        .nullable()
        .default(null),
    operatorHourKop: z
        .number()
        .int()
        .min(0)
        .max(10000000)
        .nullable()
        .default(null),
    operatorCostMode: z.enum(["per_lead", "talk_time"]).default("per_lead"),
    operatorLeadKop: z
        .number()
        .int()
        .min(0)
        .max(10000000)
        .nullable()
        .default(null),
    includeOperatorCost: z.boolean().default(true),
    sashaMinuteKop: z
        .number()
        .int()
        .min(0)
        .max(100000)
        .nullable()
        .default(null),
    sashaBillingStepSeconds: z.union([z.literal(1), z.literal(60)]).default(60),
    reviewCostPerCallKop: z
        .number()
        .int()
        .min(0)
        .max(100000)
        .nullable()
        .default(null),
    dailyAttemptLimit: z.number().int().min(1).max(100_000),
    maxAttemptsPerContact: z.number().int().min(1).max(42),
    attemptsPerDay: z.number().int().min(1).max(6).default(6),
    campaignDays: z.number().int().min(1).max(7).default(3),
    retryJitterMinutes: z.number().int().min(0).max(30).default(15),
    stopAfterHumanNoKey: z.boolean().default(true),
    stopAfterHumanHangup: z.boolean().default(true),
    humanHangupMinSeconds: z.number().int().min(1).max(30).default(3),
    retryNoAnswer: z.boolean().default(true),
    retryMachine: z.boolean().default(true),
    retryTechnicalFailure: z.boolean().default(true),
    postCallAnalysis: z.boolean().default(true),
    analysisWaitMinutes: z.number().int().min(1).max(60).default(15),
    dialTimeoutSeconds: z.number().int().min(10).max(60).default(35),
    retryMinutes: z.number().int().min(30).max(10_080),
    callWindowStart: z.number().int().min(0).max(23),
    callWindowEnd: z.number().int().min(1).max(24),
    digitTimeoutSeconds: z.number().int().min(1).max(30),
    overflowMode: z.enum(["ai", "callback"]),
    aiInstructions: z.string().max(8000),
})
    .strict()
    .refine((v) => v.transferMode !== "sasha_only" ||
    (v.aiProvider === "sasha" && v.sashaInboundTarget.length > 0), {
    message: "Для режима «Только Sasha» выберите Sasha AI и укажите маршрут",
    path: ["sashaInboundTarget"],
})
    .refine((v) => v.callWindowEnd > v.callWindowStart, {
    message: "Конец окна должен быть позже начала",
    path: ["callWindowEnd"],
});
export const pressOneSaveSchema = z
    .object({
    version: z.number().int().positive(),
    config: pressOneConfigSchema,
})
    .strict();
export const pressOneCommandSchema = z
    .object({
    command: z.enum(["start", "pause"]),
    version: z.number().int().positive(),
})
    .strict();
export const pressOneAudioIdSchema = z.object({ id: audioId });
export const pressOneUploadQuerySchema = z.object({
    name: z.string().trim().min(1).max(120),
});
//# sourceMappingURL=press-one.dto.js.map